enum InventoryStatus {
	PENDING = 'PENDING', 
	CANCELLED = 'CANCELLED', 
	APPROVED = 'APPROVED'
}

export default InventoryStatus;